import { ACTIONS } from '../actions';

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: null,
  slotsError: null,
  eventSlotsYear: null,
  user: {
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
    address: '',
  },
  booking: {
    service_slot_id: 0,
    date: new Date(),
  },
  shop: undefined,
  schedules: [],
  slots: [],
  event: undefined,
  confirmedUser: null,
  confirmedBooking: null,
  confirmedShop: null,
};

export const service = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.USER_DETAILS_SUBMIT:
      return {
        ...state,
        user: action.payload,
        error: null,
      };
    case ACTIONS.BOOKING_DETAILS_SUBMIT:
      return {
        ...state,
        booking: action.payload,
      };
    case ACTIONS.SUBMIT_PURCHASE_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTIONS.SUBMIT_PURCHASE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        confirmedUser: action.payload?.confirmed?.user ?? state.user,
        confirmedBooking: action.payload?.confirmed?.booking ?? state.booking,
        confirmedShop: action.payload?.confirmed?.shop ?? state.shop,
      };
    case ACTIONS.SUBMIT_PURCHASE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTIONS.CANCEL_BOOKING_START:
      return {
        ...state,
        loading: true,
      };
    case ACTIONS.CANCEL_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case ACTIONS.CANCEL_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case ACTIONS.GET_SHOP_INFO_START:
      return {
        ...state,
        loading: true,
        shop: action.payload.shop,
        schedules: action.payload.schedules ?? [],
        slots: action.payload.slots ?? [],
      };
    case ACTIONS.GET_SHOP_INFO_SUCCESS:
      return {
        ...state,
        loading: false,
        shop: action.payload.shop,
        schedules: action.payload.schedules ?? [],
        slots: action.payload.slots ?? [],
      };
    case ACTIONS.GET_SHOP_INFO_FAILURE:
      return {
        ...state,
        loading: false,
        shop: action.payload.shop,
        schedules: action.payload.schedules ?? [],
        slots: action.payload.slots ?? [],
      };
    case ACTIONS.GET_EVENT_START:
      return {
        ...state,
        loading: true,
        event: undefined,
      };
    case ACTIONS.GET_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        event: action.payload.event,
      };
    case ACTIONS.GET_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.event.error,
      };

    case ACTIONS.GET_EVENT_SLOTS_START:
      return {
        ...state,
        loading: true,
        slots: [],
        slotsError: null,
        eventSlotsYear: null,
      };
    case ACTIONS.GET_EVENT_SLOTS_SUCCESS:
      return {
        ...state,
        loading: false,
        schedules: action.payload.schedules ?? [],
        slots: action.payload.slots ?? [],
        eventSlotsYear: action.payload.eventSlotsYear ?? null,
      };
    case ACTIONS.GET_EVENT_SLOTS_FAILURE:
      return {
        ...state,
        loading: false,
        schedules: action.payload.schedules ?? [],
        slots: action.payload.slots ?? [],
        slotsError: action.payload,
        eventSlotsYear: null,
      };
    case ACTIONS.GET_SERVICE_SLOT_START:
      return {
        ...state,
        loading: true,
        serviceSlot: undefined,
      };
    case ACTIONS.GET_SERVICE_SLOT_SUCCESS:
      return {
        ...state,
        loading: false,
        serviceSlot: action.payload,
      };
    case ACTIONS.GET_SERVICE_SLOT_FAILURE:
      return {
        ...state,
        loading: false,
        serviceSlotError: action.payload,
      };

    case ACTIONS.SUBMIT_EVENT_BOOKING_START:
    case ACTIONS.SUBMIT_EVENT_WAITLIST_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTIONS.SUBMIT_EVENT_BOOKING_SUCCESS:
    case ACTIONS.SUBMIT_EVENT_WAITLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case ACTIONS.SUBMIT_EVENT_BOOKING_FAILURE:
    case ACTIONS.SUBMIT_EVENT_WAITLIST_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
